<template>
  <a-modal
    :visible="visible"
    :title="title"
    @cancel="handleCancel"
    width="800px"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('直播课程.教师姓名')" prop="teacherName">
        <a-input v-model="form.teacherName" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item :label="$t('直播课程.教师头像')" prop="teacherAvatar">
        <OssUploadSingle v-model="form.teacherAvatar" type="img" :maxSize="200"></OssUploadSingle>
      </a-form-model-item>
      <a-form-model-item :label="$t('直播课程.教师年龄')" prop="teacherAge">
        <a-input-number v-model="form.teacherAge" :min="0" :max="150" />
      </a-form-model-item>
      <a-form-model-item :label="$t('直播课程.教师性别')" prop="teacherGender">
        <a-select v-model="form.teacherGender" style="width: 200px">
          <a-select-option :value="0">未知</a-select-option>
          <a-select-option :value="1">男</a-select-option>
          <a-select-option :value="2">女</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('直播课程.教师简介')" prop="teacherIntroduction">
        <a-textarea v-model="form.teacherIntroduction" :rows="4" :maxLength="500" />
      </a-form-model-item>
      <a-form-model-item :label="$t('直播课程.教师风采')" prop="teacherImages">
        <OssUploadMulti v-model="form.teacherImages" :isArrayData="true" :max-count="10" prefix="teacher" type="img"></OssUploadMulti>
      </a-form-model-item>
<!--      <a-form-model-item :label="$t('通用.文本.备注')" prop="remark">-->
<!--        <a-textarea v-model="form.remark" :rows="2" :maxLength="500" />-->
<!--      </a-form-model-item>-->
    </a-form-model>
    <template slot="footer">
      <a-button @click="handleCancel">{{$t('通用.按钮.取消')}}</a-button>
      <a-button type="primary" @click="submitForm">{{$t('通用.按钮.确定')}}</a-button>
    </template>
  </a-modal>
</template>

<script>
import { getLiveTeacher, addLiveTeacher, updateLiveTeacher } from '@/api/livecourse/liveTeacher'
import OssUploadSingle from '@/components/OssUploadSingle'
import OssUploadMulti from '@/components/OssUploadMulti'

export default {
  name: 'TeacherCreateForm',
  components: {
    OssUploadSingle,
    OssUploadMulti
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      visible: false,
      title: '',
      form: {
        id: undefined,
        teacherName: undefined,
        teacherAvatar: undefined,
        teacherAge: undefined,
        teacherGender: 0,
        teacherIntroduction: undefined,
        teacherImages: [],
        remark: undefined
      },
      rules: {
        teacherName: [{ required: true, message: '请输入教师姓名', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    if (this.id) {
      this.handleUpdate(this.id)
    }
  },
  methods: {
    handleAdd() {
      this.title = '新增教师'
      this.form = {
        id: undefined,
        teacherName: undefined,
        teacherAvatar: undefined,
        teacherAge: undefined,
        teacherGender: 0,
        teacherIntroduction: undefined,
        teacherImages: [],
        remark: undefined
      }
      this.visible = true
    },
    handleUpdate(row) {
      this.title = '修改教师'
      const id = typeof row === 'object' ? row.id : row
      getLiveTeacher(id).then(res => {
        this.form = { ...res.data }
        if (this.form.teacherImages) {
          try {
            this.form.teacherImages = JSON.parse(this.form.teacherImages)
          } catch (e) {
            this.form.teacherImages = []
          }
        } else {
          this.form.teacherImages = []
        }
        this.visible = true
      })
    },
    handleCancel() {
      this.visible = false
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = { ...this.form }
          if (data.teacherImages && data.teacherImages.length > 0) {
            data.teacherImages = data.teacherImages
          } else {
            data.teacherImages = []
          }
          if (data.id) {
            updateLiveTeacher(data).then(() => {
              this.$message.success('修改成功')
              this.visible = false
              this.$emit('ok')
            })
          } else {
            addLiveTeacher(data).then(() => {
              this.$message.success('新增成功')
              this.visible = false
              this.$emit('ok')
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
